// extracted by mini-css-extract-plugin
export default {"background":"Authentication_background__NF7UL"};